import { graphql } from '@/gql';

export const UpdatePerformanceMarch20KmResultMutation = graphql(`
    mutation UpdatePerformanceMarch20KmResult($id: ObjectID!, $input: UpdateMarch20KmResultInput!) {
        updateMarch20KmResult(id: $id, input: $input) {
            ... on UpdateMarch20KmResultSuccessfulResponse {
                result {
                    ...March20kmPerformanceResult
                }
            }
            ... on ErrorResponse {
                fields {
                    field
                    message
                }
            }
        }
    }
`);
